/** Shared HTTP client timeout for entity save operations (audit, recommendation, etc.). */
export const API_ENTITY_SAVE_TIMEOUT_MS = 60000;

export const API_ENTITY_SAVE_TIMEOUT_MESSAGE =
  'Saving took too long. Please try again. If the issue persists, contact IT.';
